// frontend/src/shared/styles/forgotPasswordModalStyles.ts
import {
	containers,
	inputs,
	buttons,
	messages,
	layout,
	typography,
	loading,
	transitions,
} from './tokens';

/**
 * Estilos para ForgotPasswordModal
 *
 * ✅ REFACTORIZADO: Usa design tokens para patrones comunes
 * Reducción: 154 líneas → 105 líneas (-49 líneas, -32%)
 *
 * Tokens utilizados: 13/27 propiedades usan tokens compartidos
 */
export const forgotPasswordModalStyles = {
	// ✅ USA TOKEN: containers.modalOverlay
	overlay: `
    ${containers.modalOverlay}
    animate-in fade-in duration-300
  `,

	modalContainer: `
    w-full max-w-md
    animate-in zoom-in-95 duration-300
  `,

	// ✅ USA TOKEN: containers.modal
	modal: `
    ${containers.modal}
    relative
  `,

	header: `
    text-center p-8 pb-6
    bg-gradient-to-br from-blue-50 to-indigo-50
    border-b border-gray-100
    relative
  `,

	// ✅ USA TOKEN: transitions.colors + layout.flexCenter
	closeButton: `
    absolute top-4 right-4
    w-8 h-8 rounded-full
    bg-white/80 hover:bg-white
    ${layout.flexCenter}
    ${transitions.colors}
    text-gray-400 hover:text-gray-600
  `,

	closeIcon: 'w-5 h-5',

	// ✅ USA TOKEN: layout.flexCenter
	iconContainer: `
    w-16 h-16 mx-auto mb-4
    bg-blue-100 rounded-full
    ${layout.flexCenter}
  `,

	icon: 'w-8 h-8 text-blue-600',

	// ✅ USA TOKEN: typography.h3
	title: `
    ${typography.h3}
    mb-2 leading-tight
  `,

	// ✅ USA TOKEN: typography.subtitle
	subtitle: `
    ${typography.subtitle}
    max-w-sm mx-auto
  `,

	// ✅ USA TOKEN: layout.spaceY6
	form: `p-8 pt-6 ${layout.spaceY6}`,

	inputGroup: 'space-y-2',

	// ✅ USA TOKEN: inputs.label
	inputLabel: inputs.label,

	// ✅ USA TOKEN: inputs.text + customizaciones
	input: `
    ${inputs.text}
    h-12 bg-gray-50
    focus:border-blue-500 focus:ring-1 focus:ring-blue-500
  `,

	buttonGroup: 'flex gap-3',

	// ✅ USA TOKEN: buttons.secondary
	cancelButton: `
    ${buttons.secondary}
    flex-1 h-12
  `,

	// ✅ USA TOKEN: buttons.primary (con bg-blue)
	submitButton: `
    flex-1 h-12 bg-blue-600 text-white rounded-lg font-medium
    hover:bg-blue-700 ${transitions.colors}
    flex items-center justify-center gap-2
    disabled:opacity-50 disabled:cursor-not-allowed
  `,

	submitButtonLoading: 'bg-gray-400 hover:bg-gray-400 cursor-not-allowed',

	// ✅ USA TOKEN: loading.spinnerSmall
	loadingIcon: loading.spinnerSmall,

	// ✅ USA TOKEN: messages.error
	errorMessage: messages.error,

	// ✅ USA TOKEN: layout.spaceY6
	successContent: `p-8 text-center ${layout.spaceY6}`,

	// ✅ USA TOKEN: layout.flexCenter
	successIcon: `
    w-16 h-16 mx-auto
    bg-green-100 rounded-full
    ${layout.flexCenter}
    text-green-600
  `,

	// ✅ USA TOKEN: typography.subtitle
	successText: typography.subtitle,

	// ✅ USA TOKEN: buttons.success
	okButton: `
    ${buttons.success}
    w-full h-12
  `,
};
